import React from "react"

import { useCurrency } from "../../hooks/useCurrency"
import { useLocation } from "../../hooks/useLocation"

export const withPrice = Component => ({ name = "Price", price = {}, compareAtPrice = {}, layout, className }) => {
  const { formatCurrency } = useCurrency()
  const { amount: priceAmount, currencyCode: rawCurrencyCode, currency_code } = price
  let { amount: compareAtPriceAmount } = compareAtPrice
  const { locationCurrency } = useLocation()
  const currencyCode = rawCurrencyCode || currency_code

  if (typeof compareAtPrice == "number") compareAtPriceAmount = compareAtPrice
  const onSale = compareAtPriceAmount > priceAmount

  const formattedPrice = priceAmount ? formatCurrency(Number(priceAmount), currencyCode, 2) : ""
  const formattedCompareAtPrice = compareAtPriceAmount ? formatCurrency(Number(compareAtPriceAmount), currencyCode, 2) : ""
  Component.displayName = name
  return (
    <Component
      onSale={onSale}
      price={formattedPrice}
      comparedPrice={formattedCompareAtPrice}
      currencyCode={currencyCode}
      locationCurrency={locationCurrency}
      layout={layout}
      className={className}
    />
  )
}
